var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#292E30",
    d: "M3.9 7H20.1C20.3387 7 20.5676 6.89464 20.7364 6.70711C20.9052 6.51957 21 6.26522 21 6C21 5.73478 20.9052 5.48043 20.7364 5.29289C20.5676 5.10536 20.3387 5 20.1 5H3.9C3.66131 5 3.43239 5.10536 3.2636 5.29289C3.09482 5.48043 3 5.73478 3 6C3 6.26522 3.09482 6.51957 3.2636 6.70711C3.43239 6.89464 3.66131 7 3.9 7ZM20.1 17H3.9C3.66131 17 3.43239 17.1054 3.2636 17.2929C3.09482 17.4804 3 17.7348 3 18C3 18.2652 3.09482 18.5196 3.2636 18.7071C3.43239 18.8946 3.66131 19 3.9 19H20.1C20.3387 19 20.5676 18.8946 20.7364 18.7071C20.9052 18.5196 21 18.2652 21 18C21 17.7348 20.9052 17.4804 20.7364 17.2929C20.5676 17.1054 20.3387 17 20.1 17ZM20.1 11H3.9C3.66131 11 3.43239 11.1054 3.2636 11.2929C3.09482 11.4804 3 11.7348 3 12C3 12.2652 3.09482 12.5196 3.2636 12.7071C3.43239 12.8946 3.66131 13 3.9 13H20.1C20.3387 13 20.5676 12.8946 20.7364 12.7071C20.9052 12.5196 21 12.2652 21 12C21 11.7348 20.9052 11.4804 20.7364 11.2929C20.5676 11.1054 20.3387 11 20.1 11Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.97da7d1e.svg";
export { ForwardRef as ReactComponent };